import * as Yup from "yup";
// define your fields
export const initialValues = {name: "",color: "", isActive: true};

// define validation rules
export const validationSchema = Yup.object({
    name: Yup.string().required("نام را وارد کنید"),
    isActive: Yup.boolean()
})